import { render, staticRenderFns } from "./specialevent.vue?vue&type=template&id=0a05dd34&scoped=true&"
import script from "./specialevent.vue?vue&type=script&lang=js&"
export * from "./specialevent.vue?vue&type=script&lang=js&"
import style0 from "./specialevent.vue?vue&type=style&index=0&id=0a05dd34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05dd34",
  null
  
)

export default component.exports